import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { captureSignupSource } from "./lib/attribution";

captureSignupSource();

createRoot(document.getElementById("root")!).render(<App />);
